'use strict';

class TwerLayers {

  layerMappings = {
    place_labels: 'showPlaceLabels',
    road_labels: 'showRoadLabels',
    points_of_interest: 'showPointOfInterestLabels',
    transit_labels: 'showTransitLabels',
  };

  constructor() {
    this.mapStylesElement = document.getElementById('map_styles');
    this.layersTypes = ['showPlaceLabels', 'showRoadLabels', 'showPointOfInterestLabels', 'showTransitLabels'];


    TWER.map.on('style.load', () => {
      this.handleStyleLoad();
    });

    this.mapStylesElement.addEventListener('change', event => {
      this.toggleLayerSettings();
    });



    document.addEventListener('change', (event) => {
      if (!event.target.name.startsWith('_treweler_map_layers')) return;
      this.handleStyleLoad();
    });

    this.toggleLayerSettings();
  }


  toggleLayerSettings() {
    const mapStyle = this.mapStylesElement.value;
    const checkedBoxes = document.querySelectorAll('input[name^="_treweler_map_layers"]');
    const layersTab = document.getElementById('twer-nav-layers-tab');

    if (mapStyle === 'mapbox://styles/mapbox/navigation-guidance-day-v4' || mapStyle === 'mapbox://styles/mapbox/navigation-guidance-night-v4' || jQuery('#custom_style').val().trim() !== '') {
      layersTab.classList.add('d-none');
      jQuery('#twer-nav-general-tab').tab('show');
    } else {
      layersTab.classList.remove('d-none');
    }



    [...checkedBoxes].map(element => {
      if (mapStyle === 'mapbox://styles/mapbox/standard-beta') {
        if (this.layerMappings[element.value]) {
          if (element.value === 'place_labels') {
            element.closest('.section-treweler-map-layers').classList.add('is-first-row');
          }
          element.closest('.section-treweler-map-layers').classList.remove('d-none');
        } else {
          element.closest('.section-treweler-map-layers').classList.add('d-none');
        }
      } else if (mapStyle === 'mapbox://styles/mapbox/navigation-guidance-day-v4' || mapStyle === 'mapbox://styles/mapbox/navigation-guidance-night-v4') {
        element.checked = true;
      } else {
        element.closest('.section-treweler-map-layers').classList.remove('is-first-row');
        element.closest('.section-treweler-map-layers').classList.remove('d-none');
      }
    });
  }



  getCheckboxValues() {
    const checkedBoxes = document.querySelectorAll('input[name^="_treweler_map_layers"]:checked');
    return [...checkedBoxes].map(element => this.layerMappings[element.value] || element.value);
  }

  setLayerVisibility(layerId, visibility) {
    TWER.map.setLayoutProperty(layerId, 'visibility', visibility ? 'visible' : 'none');
  }

  updateLayerVisibility(layers, activeLayers, layerType) {
    layers.forEach(layerId => {
      this.setLayerVisibility(layerId, activeLayers.includes(layerType));
    });
  }

  handleStyleLoad() {
    const activeLayers = this.getCheckboxValues();



    if (this.mapStylesElement.value === 'mapbox://styles/mapbox/standard-beta') {
      this.layersTypes.forEach(item => {
        TWER.map.setConfigProperty('basemap', item, activeLayers.includes(item));
      });
    } else {
      if(jQuery('#custom_style').val().trim() === '') {
        this.updateMapLayers();
      }
    }
  }


  updateMapLayers() {
    const activeLayers = this.getCheckboxValues();
    const layerGroups = {
      showPlaceLabels: [
        'continent-label',
        'country-label',
        'state-label',
        'settlement-major-label',
        'settlement-minor-label',
        'settlement-subdivision-label',
      ],
      showRoadLabels: [
        'road-exit-shield',
        'road-label-simple',
        'road-exit-shield-navigation',
        'road-number-shield',
        'road-number-shield-navigation',
        'road-label-navigation',
        'road-label',
        'road-intersection'
      ],
      showPointOfInterestLabels: ['poi-label'],
      showTransitLabels: [
        'airport-label',
        'transit-label',
        'ferry-aerialway-label',
      ],
      boundaries: [
        'admin-0-boundary-disputed',
        'admin-0-boundary',
        'admin-1-boundary',
        'admin-0-boundary-bg',
        'admin-1-boundary-bg',
      ],
      building_labels: [
        'block-number-label',
        'building-number-label',
        'building-entrance',
      ],
      buildings: [
        'building',
        'building-underground',
        'building-outline',
      ],
      natural_features: [
        'water-point-label',
        'water-line-label',
        'natural-point-label',
        'natural-line-label',
        'waterway-label',
      ],
      pedestrian_labels: [
        'golf-hole-label',
        'path-pedestrian-label',
      ],
      pedestrian_roads: [
        'bridge-pedestrian',
        'bridge-steps',
        'bridge-path',
        'bridge-pedestrian-case',
        'bridge-steps-bg',
        'bridge-path-bg',
        'golf-hole-line',
        'road-pedestrian',
        'road-steps',
        'road-path',
        'road-pedestrian-case',
        'road-steps-bg',
        'road-path-bg',
        'road-pedestrian-polygon-pattern',
        'road-pedestrian-polygon-fill',
        'tunnel-pedestrian',
        'tunnel-steps',
        'tunnel-path',
        'gate-label',
        'bridge-path-cycleway-piste',
        'bridge-path-trail',
        'road-path-cycleway-piste',
        'road-path-trail',
        'tunnel-path-cycleway-piste',
        'tunnel-path-trail',
      ],
      transit : [
        'aerialway',
        'bridge-rail-tracks',
        'bridge-rail',
        'road-rail-tracks',
        'road-rail',
        'ferry-auto',
        'ferry',
        'aeroway-line',
        'aeroway-polygon',
      ],
      roads : [
        "bridge-oneway-arrow-white",
        "bridge-oneway-arrow-blue",
        "bridge-motorway-trunk-2",
        "bridge-major-link-2",
        "bridge-motorway-trunk-2-case",
        "bridge-major-link-2-case",
        "bridge-motorway-trunk",
        "bridge-primary",
        "bridge-secondary-tertiary",
        "bridge-street-low",
        "bridge-street",
        "bridge-major-link",
        "bridge-minor-link",
        "bridge-minor",
        "bridge-construction",
        "bridge-motorway-trunk-case",
        "bridge-major-link-case",
        "bridge-primary-case",
        "bridge-secondary-tertiary-case",
        "bridge-minor-link-case",
        "bridge-street-case",
        "bridge-minor-case",
        "crosswalks",
        "road-oneway-arrow-white",
        "road-oneway-arrow-blue",
        "level-crossing",
        "road-motorway-trunk",
        "road-primary",
        "road-secondary-tertiary",
        "road-street-low",
        "road-street",
        "road-major-link",
        "road-minor-link",
        "road-minor",
        "road-construction",
        "turning-feature",
        "road-motorway-trunk-case",
        "road-major-link-case",
        "road-primary-case",
        "road-secondary-tertiary-case",
        "road-minor-link-case",
        "road-street-case",
        "road-minor-case",
        "turning-feature-outline",
        "road-polygon",
        "tunnel-oneway-arrow-white",
        "tunnel-oneway-arrow-blue",
        "tunnel-motorway-trunk",
        "tunnel-primary",
        "tunnel-secondary-tertiary",
        "tunnel-street-low",
        "tunnel-street",
        "tunnel-major-link",
        "tunnel-minor-link",
        "tunnel-minor",
        "tunnel-construction",
        "tunnel-motorway-trunk-case",
        "tunnel-major-link-case",
        "tunnel-primary-case",
        "tunnel-secondary-tertiary-case",
        "tunnel-minor-link-case",
        "tunnel-street-case",
        "tunnel-minor-case",
        "bridge-simple",
        "bridge-case-simple",
        "road-simple",
        "tunnel-simple",
        "incident-startpoints-navigation",
        "incident-endpoints-navigation",
        "incident-closure-line-highlights-navigation",
        "incident-closure-lines-navigation",
        "traffic-bridge-oneway-arrow-white-navigation",
        "traffic-bridge-oneway-arrow-blue-navigation",
        "traffic-road-oneway-arrow-white-navigation",
        "traffic-road-oneway-arrow-blue-navigation",
        "traffic-tunnel-oneway-arrow-white-navigation",
        "traffic-tunnel-oneway-arrow-blue-navigation",
        "traffic-level-crossing-navigation",
        "traffic-bridge-road-motorway-trunk-navigation",
        "traffic-bridge-road-motorway-trunk-case-navigation",
        "traffic-bridge-road-major-link-navigation",
        "traffic-bridge-road-primary-navigation",
        "traffic-bridge-road-secondary-tertiary-navigation",
        "traffic-bridge-road-street-navigation",
        "traffic-bridge-road-minor-navigation",
        "traffic-bridge-road-link-navigation",
        "bridge-motorway-trunk-2-navigation",
        "bridge-major-link-2-navigation",
        "bridge-motorway-trunk-2-case-navigation",
        "bridge-major-link-2-case-navigation",
        "bridge-motorway-trunk-navigation",
        "bridge-primary-navigation",
        "bridge-secondary-tertiary-navigation",
        "bridge-street-navigation",
        "bridge-minor-navigation",
        "bridge-major-link-navigation",
        "bridge-construction-navigation",
        "bridge-motorway-trunk-case-navigation",
        "bridge-major-link-case-navigation",
        "bridge-primary-case-navigation",
        "bridge-secondary-tertiary-case-navigation",
        "bridge-street-case-navigation",
        "bridge-street-low-navigation",
        "bridge-minor-case-navigation",
        "turning-feature-navigation",
        "level-crossing-navigation",
        "traffic-tunnel-motorway-trunk-navigation",
        "road-motorway-trunk-navigation",
        "traffic-tunnel-major-link-navigation",
        "road-motorway-trunk-case-low-navigation",
        "traffic-tunnel-primary-navigation",
        "road-primary-navigation",
        "traffic-tunnel-secondary-tertiary-navigation",
        "road-secondary-tertiary-navigation",
        "traffic-tunnel-street-navigation",
        "road-street-navigation",
        "traffic-tunnel-minor-navigation",
        "traffic-tunnel-link-navigation",
        "road-minor-navigation",
        "road-major-link-navigation",
        "road-construction-navigation",
        "road-motorway-trunk-case-navigation",
        "road-major-link-case-navigation",
        "road-primary-case-navigation",
        "road-secondary-tertiary-case-navigation",
        "road-street-case-navigation",
        "road-street-low-navigation",
        "road-minor-case-navigation",
        "turning-feature-outline-navigation",
        "tunnel-motorway-trunk-navigation",
        "tunnel-primary-navigation",
        "tunnel-secondary-tertiary-navigation",
        "tunnel-street-navigation",
        "tunnel-minor-navigation",
        "tunnel-major-link-navigation",
        "tunnel-construction-navigation",
        "tunnel-motorway-trunk-case-navigation",
        "tunnel-major-link-case-navigation",
        "tunnel-primary-case-navigation",
        "tunnel-secondary-tertiary-case-navigation",
        "tunnel-street-case-navigation",
        "tunnel-street-low-navigation",
        "tunnel-minor-case-navigation"
      ],
      land_structure : [
        "land-structure-line",
        "land-structure-polygon",
        "pitch-outline",
        "landuse",
        "national-park",
        "landcover",
        "national-park_tint-band",
        "cliff",
        "wetland-pattern",
        "wetland"
      ],
      hillshade : [
        'hillshade'
      ],
      water_depth : [
        'water-depth'
      ],
      contour_lines : [
        'contour-label',
        'contour-line',
      ]
    };


    TWER.map.getStyle().layers.map((layer) => {
      for (const [layerType, layerIds] of Object.entries(layerGroups)) {
        if (layerIds.includes(layer.id)) {
          this.setLayerVisibility(layer.id, activeLayers.includes(layerType));
          break;
        }
      }
    });
  }
}

export default TwerLayers;

